export const TEXTS = {
  SERVICES_AND_PRODUCTS_HUB: {
    MAIN_TITLE: 'SERVICES_AND_PRODUCTS_HUB.MAIN_TITLE',
    NEW_ITEM_BUTTON: 'SERVICES_AND_PRODUCTS_HUB.NEW_ITEM_BUTTON',
    SEARCH_BAR_PLACEHOLDER: 'SERVICES_AND_PRODUCTS_HUB.SEARCH_BAR_PLACEHOLDER',
    PRODUCTS_TABLE: {
      NAME_COLUMN: 'SERVICES_AND_PRODUCTS_HUB.PRODUCTS_TABLE.NAME_COLUMN',
      DESCRIPTION_COLUMN: 'SERVICES_AND_PRODUCTS_HUB.PRODUCTS_TABLE.DESCRIPTION_COLUMN',
      PRICE_COLUMN: 'SERVICES_AND_PRODUCTS_HUB.PRODUCTS_TABLE.PRICE_COLUMN',
      EMPTY_STATE: {
        TITLE: 'SERVICES_AND_PRODUCTS_HUB.PRODUCTS_TABLE.EMPTY_STATE.TITLE',
        ADD_BUTTON: 'SERVICES_AND_PRODUCTS_HUB.PRODUCTS_TABLE.EMPTY_STATE.ADD_BUTTON',
      },
    },
    ITEM_MENU: {
      EDIT_ITEM_BUTTON: 'SERVICES_AND_PRODUCTS_HUB.ITEM_MENU.EDIT_ITEM_BUTTON',
      DELETE_ITEM_BUTTON: 'SERVICES_AND_PRODUCTS_HUB.ITEM_MENU.DELETE_ITEM_BUTTON',
    },
    DELETE_POPUP: {
      TITLE: 'SERVICES_AND_PRODUCTS_HUB.DELETE_POPUP.TITLE',
      DESCRIPTION: 'SERVICES_AND_PRODUCTS_HUB.DELETE_POPUP.DESCRIPTION',
      CANCEL_BUTTON: 'SERVICES_AND_PRODUCTS_HUB.DELETE_POPUP.CANCEL_BUTTON',
      DELETE_BUTTON: 'SERVICES_AND_PRODUCTS_HUB.DELETE_POPUP.DELETE_BUTTON',
    },
  },
} as const;
